import React, { Component } from 'react';
import { connect } from 'react-redux';
import cookie from 'react-cookies';
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from 'react-toastify';
import ReactGA from 'react-ga';
import { getImages } from '../actions/index';
import Img from 'react-image'
import Loading from './loading';
import InfiniteScroll from 'react-infinite-scroller';
import Cart from './Cart';
import { photos_url, directory, photosPrice, requireLogin } from '../config';
import Checkout from './Checkout';
import CountCartItems from './CountCartItems';
import 'react-toastify/dist/ReactToastify.css';

class Photos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      isLoading: true,
      currentPhoto: 0,
      currentPhotoSrc: '',
      lightBox: false,
      hasMore: 30,
      showCartBox: false,
      showArrows: true,
      showPaymentBox: false,
    }
    this.nextPhoto = this.nextPhoto.bind(this);
    this.prevPhoto = this.prevPhoto.bind(this);
    this.onClickPhoto = this.onClickPhoto.bind(this);
    this.onClickPhotoCart = this.onClickPhotoCart.bind(this);
    this.closeLightbox = this.closeLightbox.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.openCart = this.openCart.bind(this);
    this.onClickPhotoRemoveCart = this.onClickPhotoRemoveCart.bind(this);
    this.onClickPhotoLessCart = this.onClickPhotoLessCart.bind(this);
    this.payButton = this.payButton.bind(this);
  }

  componentWillMount() {
    const hashImage = window.location.hash;
    const image = hashImage.replace('#', '');
    if (!localStorage.cart || !localStorage.checkout) {
      localStorage.setItem('cart', '[]');
      localStorage.setItem('checkout', '[]');
    }
    // Check for browser support of service worker
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', function () {
        navigator.serviceWorker.register('sw.js').then(function (registration) {
          // Registration was successful
          console.log('ServiceWorker registration successful with scope: ', registration.scope);
        }).catch(function (err) {
          // registration failed :(
          console.log('ServiceWorker registration failed: ', err);
        });
      });
    }

    this.props.getImages(1).then(() => {
      if (this.props.images) {
        this.setState({
          images: this.props.images,
          hasMore: this.props.images.length,
          isLoading: false,
          currentPhotoSrc: image ? image : this.props.images[0].file
        })
      };
    });

    if (hashImage) {
      this.setState({
        lightBox: true,
        showArrows: false,
        currentPhotoSrc: image,
      });
    }
  }

  loadMore(page) {
    this.props.getImages(page).then(() => {
      if (this.props.images) {
        const initialImages = this.state.images;
        const nextImages = this.props.images;
        const newImages = initialImages.concat(nextImages);
        const hasMore = nextImages.length;

        this.setState({
          images: newImages,
          hasMore
        })
      };
    });
  }

  nextPhoto() {
    const { images, currentPhoto } = this.state;
    this.setState({
      currentPhoto: currentPhoto + 1,
      currentPhotoSrc: images[currentPhoto + 1].file,
    });
    ReactGA.pageview(window.location.pathname + window.location.search + window.location.hash);
    window.location.hash = images[currentPhoto + 1].file;
  }

  prevPhoto() {
    const { images, currentPhoto } = this.state;
    this.setState({
      currentPhoto: currentPhoto - 1,
      currentPhotoSrc: images[currentPhoto - 1].file,
    });
    ReactGA.pageview(window.location.pathname + window.location.search + window.location.hash);
    window.location.hash = images[currentPhoto - 1].file;
  }

  onClickPhoto(i) {
    this.setState({
      lightBox: true,
      currentPhoto: i,
      currentPhotoSrc: this.state.images[i].file,
    });
    ReactGA.pageview(window.location.pathname + window.location.search + window.location.hash);
    window.location.hash = this.state.images[i].file;
  }

  onClickPhotoCart(file) {
    this.setState({
      lightBox: true,
      showArrows: true,
      currentPhotoSrc: file,
    });
    window.location.hash = file;
    ReactGA.pageview(window.location.pathname + window.location.search + window.location.hash);
  }

  closeLightbox() {
    this.setState({
      lightBox: false,
      showArrows: true,
    });
    window.history.pushState("", document.title, window.location.pathname);
  }

  addToCart(file) {
    const photos = JSON.parse(localStorage.checkout);
    let exist = false;

    if (photos.length === 0) {
      photos.push({
        file,
        qt: 1,
        size: '15x20',
        price: photosPrice[0].price,
      });
    } else {
      for (let key of Object.keys(photos)) {
        if (photos[key].file === file) {
          photos[key].qt = photos[key].qt + 1;
          exist = true;
        }
      };

      if (!exist) {
        photos.push({
          file: file,
          qt: 1,
          size: '15x20',
          price: photosPrice[0].price,
        });
        exist = false;
      };
    }

    this.setState({ showCartBox: true });
    localStorage.setItem('checkout', JSON.stringify(photos));

    toast('A foto foi adicionada com sucesso!')
  }

  onClickPhotoRemoveCart(file) {
    const photos = JSON.parse(localStorage.checkout);
    for (let i = 0; i < photos.length; i++) {
      if (photos[i].file === file) {
        photos.splice(i, 1);
        this.setState({ photos });
        break;
      }
    };
    localStorage.setItem('checkout', JSON.stringify(photos));
  }

  onClickPhotoLessCart(file) {
    let cart = JSON.parse(localStorage.cart);
    for (let i = 0; i < cart.length; i++) {
      if (cart[i] === file) {
        cart.splice(i, 1);
        localStorage.setItem('cart', JSON.stringify(cart));
        this.setState({ showCartBox: true });

        break;
      }
    };
  }

  openCart() {
    const { showCartBox } = this.state;
    if (showCartBox) {
      this.setState({ showCartBox: false, showPaymentBox: false });
    } else {
      this.setState({ showCartBox: true, showPaymentBox: false });
    }
  }

  payButton() {
    this.setState({ showPaymentBox: true, showCartBox: false });
  }

  renderPhotos() {
    const { images } = this.state;

    if (images.length > 0) {
      return images.map((image, i) => {
        return (
          <div key={i} className="image-box">
            <div className="thumb" style={{ backgroundImage: `url(${photos_url}/${directory}/images/${image.thumb})` }}>
              <div className="thumb-name">
                {/*
                <button type="button" onClick={() => this.addToCart(image.file)} className="add-to-cart">Adicionar ao carrinho</button>
                 */}
                <button type="button" onClick={() => this.onClickPhoto(i, image.file)} className="thumb-button">Abrir</button>
                <span>{image.file}</span>
              </div>
            </div>
          </div>
        )
      });
    }
  }

  render() {
    if (requireLogin) {
      if (!cookie.load('_login')) {
        window.location.href = `${photos_url}/${directory}/login.php`;
        return false;
      }
    }

    const {
      isLoading,
      currentPhotoSrc,
      images,
      currentPhoto,
      lightBox,
      hasMore,
      showCartBox,
      showArrows,
      showPaymentBox,
    } = this.state;

    let classShowCartBox;

    if (isLoading) {
      return (<div />)
    }

    if (showCartBox) {
      classShowCartBox = 'images-box';
    } else {
      classShowCartBox = 'images-box-full';
    }

    const hashImage = window.location.hash;
    const image = hashImage ? hashImage.replace('#', '') : 'IMG_1567.jpg';

    // const shareUrl = `${window.location.origin}${window.location.pathname}share.php?url=${photos_url}/${directory}/images/large/${currentPhotoSrc}`;

    return (
      <div className="container-box">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Joel Calheiros - Photography</title>
          <link rel="canonical" href={`http://joelcalheiros.com/ssebastiao/images/large/${image}`} />
          <meta property="og:url" content={window.location.href}></meta>
          <meta property="og:title" content="Joel Calheiros - Photography"></meta>
          <meta property="og:image" content={`http://joelcalheiros.com/ssebastiao/images/large/${image}`}></meta>
        </Helmet>
        <div className="header row">
          <div className="col-6">joelcalheiros.com</div>
          {showCartBox && (
            <div className="col-6 text-right"><button type="button" onClick={this.openCart}>Voltar às fotos</button></div>
          )}
          {!showCartBox && (
            <div className="col-6 text-right"><button type="button" onClick={this.openCart}>Carrinho (<CountCartItems />)</button></div>
          )}
        </div>
        {!showPaymentBox &&
          <div className={classShowCartBox}>
            <InfiniteScroll
              key={1}
              pageStart={1}
              loadMore={this.loadMore}
              hasMore={hasMore === 30}
              loader={<div className="loader" key={0}>Loading ...</div>}
            >
              {this.renderPhotos()}
            </InfiniteScroll>
          </div>
        }
        {showPaymentBox &&
          <div className="cart-box-full">
            <Checkout
              onClickPhotoCart={this.onClickPhotoCart}
              onClickPhotoRemoveCart={this.onClickPhotoRemoveCart}
              addToCart={this.addToCart}
              onClickPhotoLessCart={this.onClickPhotoLessCart}
              payButton={this.payButton}
              cart={JSON.parse(localStorage.checkout)}
            />
          </div>
        }
        {showCartBox &&
          <div className="cart-box">
            <Cart
              onClickPhotoCart={this.onClickPhotoCart}
              onClickPhotoRemoveCart={this.onClickPhotoRemoveCart}
              addToCart={this.addToCart}
              onClickPhotoLessCart={this.onClickPhotoLessCart}
              payButton={this.payButton}
            />
          </div>
        }
        {lightBox &&
          <div className="lightbox">
            <button className="btn btn-close" onClick={this.closeLightbox}>x</button>
            <div className="text-center">
              {showArrows &&
                <button className="prev" onClick={this.prevPhoto} disabled={currentPhoto === 0}>Anterior</button>
              }
              {showArrows &&
                <button className="next" onClick={this.nextPhoto} disabled={currentPhoto + 1 >= images.length}>Seguinte</button>
              }
              <div className="photo">
                {/* <button type="button" onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?display=popup&u=${decodeURI(shareUrl)}&quote=joelcalheiros.com`)} className="add-to-cart" style={{ top: '0' }}>Share</button> */}
                <button type="button" onClick={() => this.addToCart(currentPhotoSrc)} className="add-to-cart">Adicionar ao carrinho</button>
                <Img className="img-thumbnail" src={`${photos_url}/${directory}/images/large/${currentPhotoSrc}`} loader={<Loading />} />
                <br />{currentPhotoSrc}
              </div>

            </div>
          </div>
        }
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { images: state.images.images };
}

export default connect(mapStateToProps, { getImages })(Photos);



// WEBPACK FOOTER //
// ./src/components/app.js